/* unplugin-vue-components disabled */import { render } from "./AnswerImageUploaderLegacyWrapper.vue?vue&type=template&id=040a1f02&ts=true"
import script from "./AnswerImageUploaderLegacyWrapper.vue?vue&type=script&lang=ts"
export * from "./AnswerImageUploaderLegacyWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__